import { Row } from "antd";
import TrainingCalendar from "../Calendar/TrainingCalendar";

const PatientTrainingTable = () => {
  return (
    <Row className="relative my-14 w-full">
      <TrainingCalendar />
    </Row>
  );
};

export default PatientTrainingTable;
